import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import * as Yup from 'yup';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  Paper,
  MenuItem,
  Input,
  InputAdornment,
  IconButton,
  Backdrop,
  CircularProgress,
  FormControlLabel,
  Switch,
  Stack
} from '@material-ui/core';
import ReceiptIcon from '@material-ui/icons/Receipt';
import SearchIcon from '@material-ui/icons/Search';
import { useFormikContext, useFormik, Form, FormikProvider } from 'formik';
import moment from 'moment';
import { baseUrl, batchStatuses } from '../../utils/constants';
import { useClientContext } from '../../context/client_context';
import { useClaimsContext } from '../../context/claims_context';
import { useConstantsContext } from '../../context/constants_context';
import Controls from '../controls/Controls';

export default function CreateBatches() {
  const dateToday = new Date();
  const { payCycles } = useConstantsContext();
  const { currentBatch, setCurrentBatch, clearBatch, batchNo } = useClaimsContext();
  const { customerIdentifier } = useClientContext();
  const [switchChecked, setSwitchChecked] = useState(false);
  const [docSearchCode, setSearchCode] = useState('');
  const [docSearchName, setSearchName] = useState('');
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: '#000000'
  });
  const navigate = useNavigate();

  useEffect(() => {
    getBatchById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log('isSelfPayment', currentBatch.isSelfPayment);
    setSwitchChecked(currentBatch.isSelfPayment);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentBatch]);

  if (currentBatch.batchReceivedOn)
    currentBatch.batchReceivedOn = moment(currentBatch.batchReceivedOn).format('yyyy-MM-DD');

  const CreateBatchesSchema = Yup.object().shape({
    no_of_Docs: Yup.number()
      .typeError('you must specify a # of Docs in Batch')
      .min(1, '# of Docs should be greater than 0'),
    payCycleID: Yup.number()
      .typeError('you must specify a Pay Cycle')
      .min(1, 'Pay Cycle should be greater than 0'),
    batchTotal: Yup.number()
      .typeError('you must specify a Batch Total')
      .min(1, 'Batch Total should be greater than 0'),
    batchReceivedOn: Yup.date()
      .max(new Date(), 'Should be less than today')
      .required('Batch Date Required')
  });

  const formik = useFormik({
    initialValues: currentBatch,
    enableReinitialize: true,
    validationSchema: CreateBatchesSchema,
    onSubmit: (values) => {
      if (values.payCycleID === '' || values.payCycleID === 0) {
        notifyPopup(`Pay Cycle not selected, Please select and Save Again...`, 'error');
        return;
      }
      console.log('values found', values);
      console.log('window.location.hostname', window.location.hostname);
      values.workStation = window.location.hostname;
      if (values.batchID > 0) updateBatch(values);
      else createBatch(values);
    }
  });

  const { submitForm } = formik;

  const handleSubmit = () => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    console.log('came here to submit');
    submitForm();
  };

  const getDoctorInfo = async (event) => {
    if (docSearchCode === '') {
      notifyPopup(`No AHFOZ # Selected, please enter number to seach for!`, 'error');
      return;
    }
    setLoading(true);
    await axios(`${baseUrl}/api/setting/GetProvider?namasNo=${docSearchCode}`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Provider not Found!: ${result.replyMessage}`, 'error');
        } else {
          console.log('returned doc', result);
          formik.setFieldValue('doctor_Code', result.data.namasNo);
          formik.setFieldValue('provider_Id', result.data.provider_id);
          formik.setFieldValue('userRefId', sessionStorage.getItem('oldRefId'));
          setSearchName(result.data.provider);
        }
      },
      (error) => {
        notifyPopup(`Error in Searching for Medical Practise!: ${error}`, 'error');
      }
    );
  };

  const createBatch = async (client) => {
    setLoading(true);
    const jsonClient = [];
    jsonClient.push(client);
    console.log('claims stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/claims/CreateBatches`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (res) => {
          console.log('returned batch', res);
          setLoading(false);
          clearBatch();
          // setCurrentBatch(res);
          notifyPopup(`Batches Created Successfully!`, 'success');
          navigate('/claims/selectBatch');
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Creating Batches!: ${error}`, 'error');
        }
      );
  };

  const updateBatch = async (client) => {
    setLoading(true);
    const jsonClient = [];
    jsonClient.push(client);
    console.log('claims stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/claims/SaveBatches`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (res) => {
          console.log('returned batch', res);
          setLoading(false);
          clearBatch();
          // setCurrentBatch(res);
          notifyPopup(`Batches Created Successfully!`, 'success');
          navigate('/claims/selectBatch');
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Creating Batches!: ${error}`, 'error');
        }
      );
  };

  const getBatchById = async (event) => {
    if (batchNo === -1) {
      return;
    }
    setLoading(true);
    await axios(`${baseUrl}/api/claims/getBatchById?batchId=${batchNo}`).then(
      (result) => {
        setLoading(false);
        console.log('returned batch info', result);
        setCurrentBatch(result.data.result);
      },
      (error) => {
        notifyPopup(`Error in Getting Claim!: ${error}`, 'error');
      }
    );
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate>
        <Typography component="span" variant="h6" gutterBottom>
          Create Batch
        </Typography>
        <Card>
          <CardContent>
            <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={loading}
              onClick={handleLoadingClose}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <Grid container spacing={2}>
              <Grid container spacing={2} marginTop={2}>
                <Grid item xs={8} sm={8}>
                  <Paper margin={10}>
                    <Grid item xs={3} sm={3} margin={2}>
                      <FormControl>
                        <InputLabel htmlFor="docSearchCode">Search Provider</InputLabel>
                        <Input
                          id="docSearchCode"
                          type="text"
                          value={docSearchCode}
                          onChange={(e) => {
                            setSearchCode(e.target.value);
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onMouseDown={handleMouseDownPassword}
                                onClick={() => getDoctorInfo()}
                              >
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                    </Grid>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                      <Grid item xs={4} sm={4} margin={2}>
                        <Controls.Input name="provider_Id" label="Doctor Code" disabled />
                      </Grid>
                      <Grid item xs={4} sm={4} ml={2}>
                        <FormControl>
                          <FormControlLabel
                            control={
                              <Switch
                                name="isSelfPayment"
                                value={formik.values.isSelfPayment}
                                checked={switchChecked}
                                onChange={() => {
                                  setSwitchChecked(!switchChecked);
                                  formik.setFieldValue('isSelfPayment', !switchChecked);
                                  console.log('isSelfPayment', !switchChecked);
                                }}
                              />
                            }
                            label="Self Payment"
                          />
                        </FormControl>
                      </Grid>
                    </Stack>
                    <Grid item xs={12} sm={12} margin={2}>
                      <FormControl fullWidth>
                        <InputLabel htmlFor="docSearchName">Provider Name</InputLabel>
                        <Input id="docSearchName" type="text" value={docSearchName} disabled />
                      </FormControl>
                    </Grid>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Paper variant="outlined">
                    <Grid item xs={12} sm={12} margin={2}>
                      <Controls.InputNumber name="batchID" label="Batch #" disabled />
                    </Grid>
                    <Grid item xs={12} sm={12} margin={2}>
                      <Controls.DateTime name="batchReceivedOn" label="Batch Received On" />
                    </Grid>
                    <Grid item xs={12} sm={12} margin={2}>
                      <FormControl fullWidth>
                        <InputLabel id="payCycleLbl">Pay Period</InputLabel>
                        <Select
                          id="payCycleID"
                          value={formik.values.payCycleID}
                          name="payCycleID"
                          fullWidth
                          size="small"
                          variant="outlined"
                          onChange={(e) => {
                            formik.setFieldValue('payCycleID', e.target.value);
                            console.log('e', e);
                          }}
                        >
                          <MenuItem key="" value="">
                            Not Selected
                          </MenuItem>
                          {payCycles.map((item) => (
                            <MenuItem key={item.payCycleId} value={item.payCycleId}>
                              {item.payDate}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={1} direction="column">
              <Grid container spacing={1} marginTop={2}>
                <Grid item xs={12} sm={6}>
                  <Paper margin={10}>
                    <Grid item xs={12} sm={12} margin={2} ml={8}>
                      <Controls.InputNumber name="no_of_Docs" label="No of Docs:" />
                    </Grid>
                    <Grid item xs={12} sm={12} margin={2} ml={8}>
                      <Controls.InputNumber name="self_Payments" label="Self Payments" />
                    </Grid>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Paper variant="outlined" square>
                    <Grid item xs={12} sm={12} margin={2}>
                      <Controls.InputNumber name="batchTotal" label="Value:" />
                    </Grid>
                    <Grid item xs={12} sm={12} margin={2}>
                      <Controls.InputNumber name="personal_Account" label="Personal Account:" />
                    </Grid>
                  </Paper>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6} sm={6} direction="row">
                  <Grid item xs={3} sm={4}>
                    <Controls.SelectJson
                      name="batchStatus_Id"
                      label="Batch Status"
                      options={batchStatuses}
                      disabled
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ m: 2, ml: 0 }}>
                <Grid item xs={2} sm={2}>
                  <Button
                    type="button"
                    variant="outlined"
                    color="secondary"
                    startIcon={<ReceiptIcon />}
                    onClick={() =>
                      setConfirmDialog({
                        isOpen: true,
                        title: 'Are you sure you want to Create Batch',
                        subTitle: "You can't undo this action",
                        heading: 'Create Batch Claims',
                        color: '#76ff03',
                        onConfirm: () => {
                          handleSubmit();
                        }
                      })
                    }
                  >
                    Process
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Controls.Notification notify={notify} setNotify={setNotify} />
            <Controls.ConfirmDialog
              confirmDialog={confirmDialog}
              setConfirmDialog={setConfirmDialog}
            />
          </CardContent>
        </Card>
      </Form>
    </FormikProvider>
  );
}
